import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { price } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-175" data-mp="3peam4j0ug885">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-cream/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-176" data-mp="3ud545iqzlsr7">
          <div className="flex items-center gap-3" data-id="element-177" data-mp="c5fso1pv97a5">
            <div className="min-w-0 text-xs leading-tight text-ink/60" data-id="element-178" data-mp="gy8uagq1fzi0">
              <span className="block font-semibold text-ink" data-id="element-179" data-mp="gzk00m31nhbr">
                {price.amount} {price.currency}
              </span>
              <span className="line-through" data-id="element-180" data-mp="27aznzx7p9vv">{price.original}</span> · −
              {price.discount}
            </div>
            <a href="#precio" className="flex-1 rounded-full bg-teal px-4 py-3 text-center text-sm font-semibold text-white transition-colors duration-150 ease-smooth hover:bg-teal-deep" data-id="element-181" data-mp="gwqmx5xjax6t">
              Quiero mi vientre plano
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}